import { Product } from "../model";
import { html } from "htm/preact";
import { ctx, translate } from "..";
import { useEffect, useState } from "preact/hooks";
import { isVordingborgCustomer } from "../utils";

declare global {
  interface Window {
    __SHOP_CONFIG__?: {
      allowAddToCartWhenOutOfStock?: boolean;
    };
  }
}

function AddToCartBtn({ product }: { product: Product }) {
    const { dispatch } = ctx();
    const [quantity, setQuantity] = useState(1);

    useEffect(() => {
        setQuantity(1);
    }, [product]);

    const allowAddToCartWhenOutOfStock = window.__SHOP_CONFIG__?.allowAddToCartWhenOutOfStock ?? false;

    return html`<div class="item-options text-center ${!allowAddToCartWhenOutOfStock ? `stock-${product.stockstatus}` : ""}" style="display:flex;flex-flow:row">

    <div class="input-group bootstrap-touchspin" style="width: 30%;">
        <input value=${quantity} onkeyup=${ev => setQuantity(parseInt(ev.target.value))} type="number" class="quantity-counter form-control" style="height: 100%;"/>
    </div>
    <a onclick=${() => {
            dispatch({ type: 'add', product, quantity, options: {} });
            setTimeout(() => dispatch({ type: 'endanimate' }), 700);
        }} class="btn btn-primary btn-cart waves-effect waves-float waves-light">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart">
        <circle cx="9" cy="21" r="1"></circle>
        <circle cx="20" cy="21" r="1"></circle>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
    </svg>
    <span class="add-to-cart">${isVordingborgCustomer() || translate('Add to cart')}</span>
</a>
</div>`;
}

export default function ProductCart(product: Product) {

    const { dispatch, state } = ctx();

    function getInventory(sku: string) {
        if (!state.inventory) return '';
        if (!state.inventory[sku] || state.inventory[sku] <= 0) {
            product.stockstatus = 'notavailable';
            return translate('Out of stock');
        } else {
            product.stockstatus = 'available';
            return `${translate('In stock')} - ${translate('Delivery is 1-3 working days')}`;
        }
    }

    const allowAddToCartWhenOutOfStock = window.__SHOP_CONFIG__?.allowAddToCartWhenOutOfStock ?? false;
    const stockmessage = getInventory(product.sku);
    return html`<div class="card ecommerce-card ${!allowAddToCartWhenOutOfStock ? `stock-${product.stockstatus}` : ""}">
    <div class="item-img text-center">
        <a href="/p/${product.sku}">
            
            <img fetchpriority="low" class="img-fluid card-img-top product-img" key=${product.image} src=${product.image} alt="img-placeholder" loading="lazy"  width="365" height="365" /></a>
    
            </div>
    <div class="card-body">
        <div class="item-wrapper">
            <div>
                <h6 class="item-price">${product.price?.toFixed(2).replace(".", ",")} ${translate('USD')}</h6>                
                <h6 class="item-name inventory ${product.stockstatus}">${stockmessage}</h6>
                <h6 class="item-name" style="margin-top:0;">${product.sku}</h6>
            </div>
        </div>
        <h6 class="item-name">
            <a class="text-body" style="overflow:visible;display:inline;" href="/p/${product.sku}">${product.name}</a>
            <span class="card-text item-company">By <a href="#" class="company-name" style="overflow:visible;display:inline;">${product.brand}</a></span>
        </h6>
        <p class="card-text item-description">${product.description}</p>
    </div>

        <${AddToCartBtn} product=${product}></${AddToCartBtn}>
        <div class="item-options text-center" style="position: absolute;right: 20px;bottom: 200px;">${product.labels?.map(label => html`<span class="badge rounded-pill badge-light-success">${label}</span>`)}</div>
</div>`;
}